import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import BallastDetail from '../../components/light/BallastDetail';
import { createBallastItem } from '../../redux/luminaire/ballast_actions';

class BallastCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.ballastDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newBallastItem = this.ballastDetail.getWrappedInstance().getWrappedInstance().getBallastData();
    this.props.createBallastItem(newBallastItem);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create ballast')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BallastDetail
            ref={ref => (this.ballastDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-ballast-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? 'Creating...' : 'Create'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const ballastState = state.lighting.ballast;
  return {
    errorMessage: ballastState.errorMessage,
    isCreating: ballastState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createBallastItem: luminaire =>
    dispatch(
      createBallastItem(
        luminaire.name,
        luminaire.brand_id,
        luminaire.type_id,
        luminaire.power_required,
        luminaire.description || '',
        luminaire.image,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BallastCreateModal),
);


// WEBPACK FOOTER //
// ./src/modal/ballast/BallastCreateModal.js